import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { graphql } from 'gql';
import { useDebounce } from 'uikit';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const isUniqueProjectNameGql = graphql(`
    query isUniqueProjectName($uniqueId: String, $projectName: String!) {
        isUniqueProjectName(uniqueId: $uniqueId, projectName: $projectName) {
            buttonText
            code
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const useIsUniqProjectName = (projectName: string) => {
    const dispatch = useDispatch();

    const [dataIsUniqProjectName, statusIsUniqProjectName, errorsIsUniqProjectName, requestIsUniqProjectName] =
        useRequest({
            requestId: 'isUniqueProjectName',
            query: isUniqueProjectNameGql,
            withEffect: false,
        });

    const debounceRequest = useDebounce(() => {
        if (projectName) {
            dispatch(requestIsUniqProjectName({ projectName: projectName.trim() }));
        }
    }, 300);

    const [makeResetIsUniqProjectName] = useResetStoreData({ requestId: 'isUniqueProjectName' });

    useEffect(() => {
        if (projectName?.length) {
            debounceRequest();
        }
    }, [debounceRequest, projectName]);

    return {
        dataIsUniqProjectName: dataIsUniqProjectName?.isUniqueProjectName,
        statusIsUniqProjectName,
        errorsIsUniqProjectName,
        makeResetIsUniqProjectName,
    };
};
